import React, { useCallback } from 'react';
import cx from 'classnames';

import { BetItemProvider, useBetslipState } from '@atlas/core';
import { betslipNameParser } from '@atlas/display-layouts';
import { EventLink } from '@atlas/routing';
import { BetCard } from '@atlas/ui';

import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';
import useTranslate from 'common/I18n/Interpreter';

function BetItemsList({ minOdds }) {
  const { betItems, outcomesErrors } = useBetslipState();
  const { isOrderBet, setIsOpenPopup } = useLocalBetslip();

  const t = useTranslate();

  const outcomeNameFormat = useCallback(
    (outcome, marketType, event) => betslipNameParser(outcome, marketType, event, t),
    [t],
  );

  return betItems.map(betItem => (
    <BetItemProvider betItem={betItem} key={betItem.requestId}>
      <div data-bet-id={betItem.outcomeId} data-testid="betslip-bet">
        <BetCard
          EventLink={EventLink}
          className={cx(
            !isOrderBet && minOdds && betItem.odds >= minOdds && 'bet-card-highlighted',
          )}
          invalid={outcomesErrors[betItem.outcomeId]}
          outcomeNameFormat={outcomeNameFormat}
          setIsOpenPopup={setIsOpenPopup}
        />
      </div>
    </BetItemProvider>
  ));
}

export default BetItemsList;
